import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AddTimelineEventBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const addTimelineEvent = createAsyncThunk<void, AddTimelineEventBody, { extra: Partial<Dependencies> }>(
  "timelineEvents/addTimelineEvent",
  async (body: AddTimelineEventBody, { extra: { adminRepository } }) => {
    return adminRepository!.createTimelineEvent(body);
  },
);

export const resetAddTimelineEvent = createAction("timelineEvents/resetAddTimelineEvent");
